import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SurveyContainer } from './components/SurveyContainer';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/location" element={<SurveyContainer />} />
        <Route path="/" element={<SurveyContainer />} />
      </Routes>
    </Router>
  );
}

export default App;
